const equal100tests = [
  "Neutrophils",
  "Band",
  "Lymphocytes",
  "Monocytes",
  "Eosinophils",
  "Basophils",
  "Heterophils",
  "Atypical lymphocytes",
  "Lymphoblast",
  "Monoblast",
  "Blast cell",
];

const caseEqual100FilterResult = (subTests) =>
  subTests.filter((subTest) => equal100tests.includes(subTest.name));
let MCV,
  hematocrit,
  hemoglobin,
  MCH,
  MCHC,
  RBC,
  NRC,
  WBC,
  WBCIndex,
  WBCCorrectIndex;
let errors = [];
let subTests = [];
let WBCStarter;

const caseCBC = (result, testInput = null, type = "function") => {
  errors = [];
  if (result.title === "Complete Blood Count (CBC)") {
    subTests = result.result.sub_tests;

    // set global for test that want to compare
    MCV = subTests.find((subTest) => subTest.name === "Indices MCV");
    hematocrit = subTests.find((subTest) => subTest.name === "Hematocrit");
    hemoglobin = subTests.find((subTest) => subTest.name === "Hemoglobin");
    MCH = subTests.find((subTest) => subTest.name === "MCH");
    MCHC = subTests.find((subTest) => subTest.name === "MCHC");
    RBC = subTests.find((subTest) => subTest.name === "RBC");
    NRC = subTests.find((subTest) => subTest.name === "NRC/100 WBCs");
    WBC = subTests.find((subTest) => subTest.name === "WBC");
    WBCIndex = subTests.findIndex((subTest) => subTest.name === "WBC");
    WBCCorrectIndex = subTests.findIndex((subTest) =>
      subTest.name.includes("Corrected WBC")
    );
    if (WBCCorrectIndex < 0) {
      WBCCorrectIndex = WBCIndex;
    }

    if (type === "mounted") {
      WBCStarter = subTests.find((subTest) => subTest.name === "WBC").value; // set starter WBC prepare for check NRC change WBC
    } else if (type === "watch") {
      if (testInput) {
        if (testInput === "WBC") {
          WBCStarter = subTests.find((subTest) => subTest.name === "WBC").value; // set starter WBC prepare for check NRC change WBC
        }
      }
      caseNRC(testInput); // trigger NRC for change WBC
    } else if (type === "function") {
      // check case
      caseEqual100();
      // caseMCV()
      // caseMCH()
      // caseMCHC()
      // caseHematocrit()
    }
  }

  if (errors.length > 0) {
    throw errors;
  }
};

const caseEqual100 = () => {
  if (
    caseEqual100FilterResult(subTests).filter((subTest) => !subTest.value)
      .length > 0 &&
    caseEqual100FilterResult(subTests).filter((subTest) => subTest.value)
      .length == 0
  ) {
    return;
  }
  const result = caseEqual100FilterResult(subTests).reduce(
    (prev, curr) => prev + +curr.value,
    0
  );
  if (result !== 100) {
    errors.push({
      message: `ผลรวมของ ${equal100tests.join(", ")} ไม่เท่ากับ 100`,
      canSave: false,
    });
  }
};

const caseMCV = () => {
  if (!RBC.value || !hematocrit.value || !RBC.value) {
    return;
  }

  const result = RBC.value
    ? (+hematocrit.value / +RBC.value).toFixed(2) * 10
    : 0;
  if (+MCV.value !== result) {
    errors.push({
      message: `ผลรวมของ MCV [${+MCV.value}] ไม่เท่ากับ (Hematocrit / RBC) x 10 [${result.toFixed(
        1
      )}]`,
      canSave: true,
    });
  }
};

const caseMCH = () => {
  if (!RBC.value || !hematocrit.value || !RBC.value || !MCH.value) {
    return;
  }

  const result = RBC.value
    ? (+hemoglobin.value / +RBC.value).toFixed(2) * 10
    : 0;
  if (+MCH.value !== result) {
    errors.push({
      message: `ผลรวมของ MCH [${
        MCH.value
      }] ไม่เท่ากับ (Hemoglobin / RBC) x 10 [${result.toFixed(1)}]`,
      canSave: true,
    });
  }
};

const caseMCHC = () => {
  if (!hematocrit.value || !RBC.value || !MCHC.value || !hemoglobin.value) {
    return;
  }

  const result = hematocrit.value
    ? (+hemoglobin.value / +hematocrit.value).toFixed(2) * 100
    : 0;
  if (+MCHC.value !== result) {
    errors.push({
      message: `ผลรวมของ MCHC [${
        MCHC.value
      }] ไม่เท่ากับ (Hemoglobin / Hematocrit) x 100 [${result.toFixed(1)}]`,
      canSave: true,
    });
  }
};

const caseHematocrit = () => {
  if (!hematocrit.value || !hemoglobin.value) {
    return;
  }

  if (!(+hematocrit.value >= (2.5 * +hemoglobin.value).toFixed(2))) {
    errors.push({
      message: `ค่าของ Hematocrit [${
        hematocrit.value
      }] น้อยกว่า 2.5 * Hemoglobin [${(+hemoglobin.value * 2.5).toFixed(2)}]`,
      canSave: true,
    });
  } else if (+hematocrit.value <= (3.0 * +hemoglobin.value).toFixed(2)) {
    errors.push({
      message: `Hematocrit [${hematocrit.value}] มากกว่า 3.0 * Hemoglobin [${(
        3 * +hemoglobin.value
      ).toFixed(1)}]`,
      canSave: true,
    });
  }
};

const caseNRC = (testInput) => {
  if (testInput === "NRC/100 WBCs") {
    if (!WBCStarter || !NRC.value) {
      return;
    }

    if (NRC.value >= 5) {
      const result = (+WBCStarter * 100) / (100 + +NRC.value);
      errors.push({
        message: `ปรับค่า WBC ใหม่จาก ${+WBCStarter} เป็น ${result.toFixed(2)}`,
        canSave: true,
        changeValue: result.toFixed(2),
        valueIndex: `result.sub_tests[${WBCCorrectIndex}].value = ${result.toFixed(
          2
        )}`,
      });
    }
  }
};

export default caseCBC;
